import React, { useContext } from 'react';
import cn from 'classnames';

import { ReactComponent as LangSwitchIcon } from './languageSwitchIcon.svg';
import appStyles from '../../App.module.css';
import styles from './Nav.module.css';
import LanguageContext from '../context/LanguageContext';
import LangToggler from '../UI/LangToggler';

export default function Nav({
    toggleTab,
    active,
    tabs,
    highlightedTab,
    handleToggle,
    isDesktop,
}) {
    const { language } = useContext(LanguageContext);

    return (
        <ul className={cn(styles.nav, appStyles.nav)}>
            {tabs.map((tab) => (
                <li
                    key={tab.value}
                    className={cn(styles.tab, {
                        [styles.active]:
                            active === tab.value ||
                            highlightedTab === tab.value,
                    })}
                    onClick={() => toggleTab(tab.ref, tab.value)}
                >
                    <div className={styles.icons}>{tab.icon}</div>

                    <span>{language === 'en' ? tab.value : tab.valueUA}</span>
                </li>
            ))}
            {!isDesktop && (
                <li className={cn(styles.tab)} onClick={() => handleToggle()}>
                    <div className={styles.icons}>
                        <LangSwitchIcon />
                    </div>
                    <LangToggler handleToggle={handleToggle} />
                </li>
            )}
        </ul>
    );
}
